var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.66516C16.5315 0.816515 25.6667 4.10384 25.6667 11.3821C25.6667 18.1864 17.3914 22.8341 14.7798 24.1315C14.2861 24.3767 13.714 24.3767 13.2203 24.1315C10.6087 22.8342 2.33337 18.1864 2.33337 11.3821C2.33337 4.10384 11.4686 0.816513 14 7.66516Z",
    fill: "#EEEFF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavF);
export default __webpack_public_path__ + "static/media/fav_f.2de148a19801dc6ed8714cfb05455b55.svg";
export { ForwardRef as ReactComponent };